module.exports = __webpack_public_path__ + "media/b_ppair_win.49e8418c.mp3";